interface ContactFormProps {
  formData: {
    fullName: string;
    email: string;
    phone: string;
    preferredDestination: string;
    currentEducation: string;
    additionalNotes: string;
  };
  onChange: (field: string, value: string) => void;
}

export default function ContactForm({ formData, onChange }: ContactFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <label htmlFor="fullName" className="block text-sm font-semibold text-foreground mb-2">
          Full Name *
        </label>
        <input
          type="text"
          id="fullName"
          value={formData.fullName}
          onChange={(e) => onChange('fullName', e.target.value)}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth"
          placeholder="Enter your full name"
          required
        />
      </div>
      <div>
        <label htmlFor="email" className="block text-sm font-semibold text-foreground mb-2">
          Email Address *
        </label>
        <input
          type="email"
          id="email"
          value={formData.email}
          onChange={(e) => onChange('email', e.target.value)}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth"
          placeholder="your.email@example.com"
          required
        />
      </div>
      <div>
        <label htmlFor="phone" className="block text-sm font-semibold text-foreground mb-2">
          Phone Number *
        </label>
        <input
          type="tel"
          id="phone"
          value={formData.phone}
          onChange={(e) => onChange('phone', e.target.value)}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth"
          placeholder="+91 00000 00000"
          required
        />
      </div>
      <div>
        <label htmlFor="preferredDestination" className="block text-sm font-semibold text-foreground mb-2">
          Preferred Destination *
        </label>
        <select
          id="preferredDestination"
          value={formData.preferredDestination}
          onChange={(e) => onChange('preferredDestination', e.target.value)}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth"
          required
        >
          <option value="">Select a destination</option>
          <option value="Germany">Germany</option>
          <option value="Singapore">Singapore</option>
          <option value="France">France</option>
          <option value="Russia">Russia</option>
          <option value="China">China</option>
          <option value="Japan">Japan</option>
          <option value="Vietnam">Vietnam</option>
          <option value="Philippines">Philippines</option>
          <option value="Saudi Arabia">Saudi Arabia</option>
          <option value="Dubai">Dubai</option>
          <option value="South Korea">South Korea</option>
          <option value="Undecided">Still Exploring</option>
        </select>
      </div>
      <div>
        <label htmlFor="currentEducation" className="block text-sm font-semibold text-foreground mb-2">
          Current Education Level *
        </label>
        <select
          id="currentEducation"
          value={formData.currentEducation}
          onChange={(e) => onChange('currentEducation', e.target.value)}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth"
          required
        >
          <option value="">Select your education level</option>
          <option value="High School">High School</option>
          <option value="Undergraduate">Undergraduate</option>
          <option value="Graduate">Graduate</option>
          <option value="Postgraduate">Postgraduate</option>
        </select>
      </div>
      <div>
        <label htmlFor="additionalNotes" className="block text-sm font-semibold text-foreground mb-2">
          Additional Notes (Optional)
        </label>
        <textarea
          id="additionalNotes"
          value={formData.additionalNotes}
          onChange={(e) => onChange('additionalNotes', e.target.value)}
          rows={4}
          className="w-full px-4 py-3 bg-card border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-smooth resize-none"
          placeholder="Tell us about your goals, concerns, or any specific questions you have..."
        />
      </div>
    </div>
  );
}